<span
  *ngIf="icon"
  class="icon {{ icon.name }}-icon"
  [ngClass]="icon.customClass"
  [attr.data-size]="icon.size | kebabCase"
>
  <svg>
    <use attr.xlink:href="{{ locationPath }}#{{ icon.name }}-icon"></use>
  </svg>
</span>
